export default __webpack_public_path__ + "static/media/single-02-kitchen-active.bb68d639.webp";